/**
 * NfceRejeicaoService
 *
 * Utilitário para analisar e classificar mensagens de rejeição SEFAZ.
 * Permite identificar o item (nItem) e o campo fiscal envolvido.
 */

// Padrões que indicam rejeição em nível de item
const ITEM_PATTERNS = [
  // "[nItem:1]"  ou  "[nItem: 1]"  (formato SEFAZ)
  { regex: /\[nItem\s*:\s*(\d+)\]/i, field: null },
  // "item 1"  /  "item 2"
  { regex: /\bitem\s+(\d+)\b/i,      field: null },
];

// Campos fiscais conhecidos por nome nas mensagens SEFAZ
const CAMPO_PATTERNS = [
  { regex: /\bCSOSN\b/i,      campo: "CSOSN"    },
  { regex: /\bCST\b/i,        campo: "CST"      },
  { regex: /\bCFOP\b/i,       campo: "CFOP"     },
  { regex: /\bNCM\b/i,        campo: "NCM"      },
  { regex: /\bCEST\b/i,       campo: "CEST"     },
  { regex: /\bCST\s*PIS\b/i,  campo: "CST_PIS"  },
  { regex: /\bCST\s*COFINS\b/i, campo: "CST_COFINS" },
  { regex: /\bICMS\b/i,       campo: "ICMS"     },
  { regex: /\bPIS\b/i,        campo: "PIS"      },
  { regex: /\bCOFINS\b/i,     campo: "COFINS"   },
];

/**
 * Analisa a mensagem de rejeição SEFAZ e retorna um objeto estruturado.
 *
 * @param {string|null} motivo  - Mensagem de rejeição (ex: "Rejeicao: Item com CSOSN indevido [nItem:1]")
 * @returns {{
 *   tipo:     'ITEM' | 'NOTA' | 'DESCONHECIDO',
 *   nItem:    number | null,
 *   campo:    string | null,
 *   mensagem: string
 * }}
 */
function parse(motivo) {
  const mensagem = String(motivo || "");
  let nItem = null;
  let campo = null;

  // Extrai nItem
  for (const { regex } of ITEM_PATTERNS) {
    const m = mensagem.match(regex);
    if (m) {
      nItem = parseInt(m[1], 10);
      break;
    }
  }

  // Extrai campo fiscal
  for (const { regex, campo: c } of CAMPO_PATTERNS) {
    if (regex.test(mensagem)) {
      campo = c;
      break;
    }
  }

  const tipo = nItem != null ? "ITEM" : "NOTA";

  return { tipo, nItem, campo, mensagem };
}

/**
 * Retorna os valores de CSOSN sugeridos para correção de NFC-e Simples Nacional.
 * Inclui label e descrição resumida.
 */
function csosnSugeridos() {
  return [
    { value: "102", label: "102 – Tributada pelo Simples Nacional sem permissão de crédito (recomendado)" },
    { value: "103", label: "103 – Isenção do ICMS no Simples Nacional para faixa de receita bruta" },
    { value: "300", label: "300 – Imune" },
    { value: "400", label: "400 – Não tributada pelo Simples Nacional" },
    { value: "500", label: "500 – ICMS cobrado anteriormente por substituição tributária" },
  ];
}

export default { parse, csosnSugeridos };
